import { PublicKey, Transaction } from "@solana/web3.js";
import { useConnection } from "@solana/wallet-adapter-react";
import { useState } from "react";
import Button from "@axvdex/components/common/Button";
import { Sale, SaleStatus } from "@axvdex/types/solana/outbid";
import { createCancelSaleInstruction } from "@axvdex/solana/outbidAPI/js/generated";
import { getSale } from "@axvdex/hooks/solana/useOutbid";
import { useAppDispatch } from "@axvdex/state";
import { sendToast } from "@axvdex/state/wallet/walletSlice";
import { SolanaSaleOperatorControlsProps } from "../SolanaSaleOperatorControls";

function CancelSale({ outbidSale }: SolanaSaleOperatorControlsProps) {
  const { connection } = useConnection();
  const dispatch = useAppDispatch();
  const [isLoading, setIsLoading] = useState(false);

  return (
    <div style={{ marginTop: "16px" }}>
      <h1 style={{ color: "red" }}>
        <strong>DANGER ZONE</strong>
      </h1>
      <p>
        {" "}
        This will cancel all live sales for <strong style={{ color: "red" }}>{outbidSale.name}</strong>.
      </p>{" "}
      <p>
        <strong>This action is irreversible.</strong>{" "}
      </p>
      <Button
        title={"Cancel sales"}
        btnColor="gradientOrange"
        onClick={async () => {
          const confirmed = confirm("Are you sure you want to cancel all live sales?");
          if (!confirmed) return;
          setIsLoading(true);
          try {
            // Build the transaction
            const transaction = new Transaction();
            for (const saleAddr of Object.keys(outbidSale.salesState)) {
              const sale = await getSale(connection, new PublicKey(saleAddr));
              console.log("Canceling Sale: ", sale);
              addCancelSaleInstructionToTransaction(sale, transaction);
            }

            // Send the transaction
            // const signature = await sendWithPhantomAndDebugTransaction(transaction, connection, errorFromCode);
            const signature = await window.solanaClient.sendTransaction(transaction, connection);
            await connection.confirmTransaction(signature, "finalized");
            const msg = "Live sales have been cancelled. User can now claim their funds.";
            dispatch(sendToast({ type: "tx-success", info: { msg, toastID: "" + new Date().getTime() } }));
          } catch (error: unknown) {
            console.error(error);
            const msg = error instanceof Error ? error.message : "An error occurred";
            dispatch(sendToast({ type: "tx-fail", info: { msg, toastID: "" + new Date().getTime() } }));
          } finally {
            setIsLoading(false);
          }
        }}
      >
        {isLoading ? "Executing ..." : "Cancel Live Sales"}
      </Button>
    </div>
  );
}

export default CancelSale;

// HELPERS ============================================================================================

const ALLOWED_STATES: SaleStatus[] = ["WaitingToStart", "WhitelistBidding", "Bidding", "BonusBidding"];

function addCancelSaleInstructionToTransaction(sale: Sale, transaction: Transaction) {
  if (sale.config.isCancelled) return;
  if (!ALLOWED_STATES.includes(sale.status)) return;
  const cancelTx = createCancelSaleInstruction({
    saleAccount: sale.saleAccount,
    saleAuthority: window.solanaClient.publicKey,
  });
  transaction.add(cancelTx);
}
